module.exports = __webpack_public_path__ + "static/media/French_Lea BG-37.9def0e0c.png";